import { render, staticRenderFns } from "./RiderDeleted.vue?vue&type=template&id=35f5732d"
import script from "./RiderDeleted.vue?vue&type=script&lang=js"
export * from "./RiderDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports